import * as ko from 'knockout';
import * as localisationHelper from 'localisationHelper';
import * as _ from 'underscore';

import "Content/ts/Shared/Buttons/StandardButtons/StandardButtonsBase";
import "Content/ts/Shared/Buttons/StandardButtons/Inverse/button-inverse";

export interface ConfirmationConfigurableText {
    Section: string;
    Resource: string;
}

export interface IConfirmationModalParameters {
    ShowModal: KnockoutObservable<boolean>;
    ModalTitle: string;
    ModalTitleConfigurableText: ConfirmationConfigurableText;
    ModalContent: string | KnockoutObservable<string>;
    ModalContentConfigurableText: ConfirmationConfigurableText;
    ConfirmationButtonText: string;
    ConfirmationButtonConfigurableText: ConfirmationConfigurableText;
    CancelButtonText: string;
    ShowConfirmationButton: boolean;
    ShowCancelButton: boolean;
    CancelButtonConfigurableText: ConfirmationConfigurableText;
    OnConfirm: any;
    OnCancel: any;
}

class ConfirmationModalVM {
    showModal: KnockoutObservable<boolean>;
    showConfirmationButton: KnockoutObservable<boolean>;
    showCancelButton: KnockoutObservable<boolean>;
    modalActionFocus: KnockoutObservable<boolean>;
    modalTitle: string;
    modalContent: string | KnockoutObservable<string>;
    confirmationButtonText: string;
    cancelButtonText: string;
    onConfirm: any;
    onCancel: any;
    subscriptions: KnockoutSubscription[];

    constructor(params: IConfirmationModalParameters) {
        this.showModal = params.ShowModal;
        this.onConfirm = params.OnConfirm;
        this.onCancel = params.OnCancel;

        this.subscriptions = [];

        this.modalContent = params.ModalContentConfigurableText
            ? localisationHelper.getString(params.ModalContentConfigurableText.Section, params.ModalContentConfigurableText.Resource)
            : params.ModalContent;

        this.modalTitle = params.ModalTitleConfigurableText
            ? localisationHelper.getString(params.ModalTitleConfigurableText.Section, params.ModalTitleConfigurableText.Resource)
            : params.ModalTitle;

        this.confirmationButtonText = params.ConfirmationButtonConfigurableText
            ? localisationHelper.getString(params.ConfirmationButtonConfigurableText.Section, params.ConfirmationButtonConfigurableText.Resource)
            : params.ConfirmationButtonText || "";

        this.cancelButtonText = params.CancelButtonConfigurableText
            ? localisationHelper.getString(params.CancelButtonConfigurableText.Section, params.CancelButtonConfigurableText.Resource)
            : params.CancelButtonText;

        this.showConfirmationButton = params.ShowConfirmationButton !== null && params.ShowConfirmationButton !== undefined
            ? ko.observable<boolean>(params.ShowConfirmationButton)
            : ko.observable<boolean>(true);

        this.showCancelButton = params.ShowCancelButton !== null && params.ShowCancelButton !== undefined
            ? ko.observable<boolean>(params.ShowCancelButton)
            : ko.observable<boolean>(true);

        this.modalActionFocus = ko.observable(false);

        this.setupSubscribes();
    }

    cancel = (): void => {
        if (this.onCancel) {
            this.onCancel();
        }
        this.showModal(false);
    }

    confirm = (): void => {
        if (this.onConfirm) {
            this.onConfirm();
        }
        this.showModal(false);
    }

    private setupSubscribes() {
        this.subscriptions.push(this.showModal.subscribe((value: boolean) => {
            this.modalActionFocus(value);
        }));
    }

    dispose() {
        _.each(this.subscriptions, (sub: KnockoutSubscription) => sub.dispose());
    }
}

const componentName = 'confirmation-modal'
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: ConfirmationModalVM,
    template: { require: `text!/Themes/Default/Content/ts/Shared/ConfirmationModal/${componentName}.html` }
});